import { css, type RuleSet } from 'styled-components'

const mobileQuery = 'only screen and (max-width: 768px)'

export const defaultBreakpointQueries = {
	isMobile: mobileQuery,
	isDesktop: `not (${mobileQuery})`,
}

/** All style supplied to the function will be applied when the width of the device is 768px or lower. */
export const mobileMediaQuery = <T extends object = {}>(styles: RuleSet<T>) => css<T>`
	@media ${defaultBreakpointQueries.isMobile} {
		${styles}
	}
`

/** All style supplied to the function will be applied when the width of the device is 769px or higher. */
export const desktopMediaQuery = <T extends object = {}>(styles: RuleSet<T>) => css<T>`
	@media ${defaultBreakpointQueries.isDesktop} {
		${styles}
	}
`
